<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <h5 class="modal-title" i18n>Rental Rooms</h5>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase">
          <span class="fal fa-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fal fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="info">
        <i class="fal fa-info-circle"></i>
        <p>
          <ng-container i18n
            >Some channels require at least one bathroom to be set and associated to a room.</ng-container
          ><br />
          <ng-container i18n
            >Please create a room of Room Kind "Bathroom" and associate it to some other room by selecting it on
            "Attached Bathroom" field.</ng-container
          >
        </p>
      </div>

      <form [formGroup]="form">
        <div class="row">
          <div formArrayName="rooms" class="col-sm-12">
            <ng-container *ngFor="let room of roomsArray.controls; let i = index">
              <ng-container [formGroupName]="i">
                <app-room-form
                  [form]="room"
                  [rental]="data.rental"
                  [rooms]="rooms"
                  [bathrooms]="bathrooms"
                  [index]="i"
                  (remove)="onRemoveRoom($event)"
                ></app-room-form>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <button (click)="addEmptyRoom()" class="btn btn-success text-uppercase add-room-btn" type="button" i18n>
              Add Room
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
